

<script>
export default {
    components: {
    },


    metaInfo: {
        title: 'My Status',
    },
    

    data() {
        return {
            actions: [],
            levels: ['1','2','3','4','5'],
            isLoading: false,
        };
    },

    async mounted() {
        this.isLoading = true;

        const actions = await window.axios.get('/api/user/status');

        // Remove post removed from here as we dont need to display it in the table 
        // and it messes with the display
        delete actions.data.post_removed;
        
        this.actions = actions.data;
        this.isLoading = false;

        this.$forceUpdate();
    },

    methods: {
        getCurrentStatus() {
            const { status } = this.$store.getters;

            if (status === '1') return 'Bronze';
            if (status === '2') return 'Silver';
            if (status === '3') return 'Gold';
            if (status === '4') return 'Platinum';
            if (status === '5') return 'Diamond';

            return 'Bronze';
        },
    },
};
</script>

<template lang='pug' src='./template/Status.pug'></template>
<style lang='stylus' src='./styles/Status.styl' scoped></style>
